module.exports = __webpack_public_path__ + "03_short_yellow.1a102226.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_short_yellow.png
// module id = FYxJ
// module chunks = 0